import React from 'react'
import 'antd/dist/antd.css';
import '../New/index.scss'
import { PAGE_COMPANY } from '../../config'
import Top from '../../components/common/TopBack/index'
import { Layout, Input, Button, Row, message, Typography, Table, Form, DatePicker, Tabs, Popconfirm, } from 'antd';
import {
    getNewsListHouTai, deleteNews,getQiNiuToken
} from '../../utils/api'
import actionWays from "../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Construction from './components/Construction';
import UpdateConstruction from './components/UpdateConstruction';
import Particulars from './components/Particulars'
import moment from "moment";
const { TabPane } = Tabs;

const { Content } = Layout;
const { Title } = Typography;
class New extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newContent: {},
            pageContent: [],
            current: 1,
            status: 0,
            loading: true,
            title: '',
            recordTime: '',
            updateConstructionVisible: false,
            constructionVisible: false,
            particularsVisible: false,
            particularsContent: {},
            updateConstructionContent: {},
        };
        this.industryNews = null
    }

    componentDidMount() {
        console.log(this.props.userLoginInfo);
        this.getPages()

    }
    getPages = async () => {
        this.setState({
            loading: true
        })
        let opt = {}
        const { current, status, title, recordTime } = this.state
        let str = status + ''
        let arr = str.split('')

        opt.pageIndex = current - 1,
            opt.title = title,
            opt.recordTime = recordTime,
            opt.pageSize = 20,
            opt.status = arr
        let data = await getNewsListHouTai(opt)
        if (data.code == 0) {
            this.setState({
                newContent: data.data,
                pageContent: data.data,
                loading: false
            })
        } else {
            if (!!data) {
                message.error(data.message)
            } else {
                message.error('接口异常')
                this.setState({
                    loading: false
                })
            }
        }
        
        const result = await getQiNiuToken();
        if (result) {
            localStorage.setItem('qiniuToken', result)
        }
    }
    componentWillUnmount() {
    }
    getParticulars = (value) => {
        this.setState({
            particularsContent: value
        }, () => {
            this.handleParticularsVisible(true)
        })
    }
    getUpdateConstruction = (value) => {
        this.setState({
            updateConstructionContent: value
        }, () => {
            this.handleUpdateConstructionVisible(true)
        })
    }
    delete = async (e) => {
        let opt = {}
        opt.id = e.nid
        let data = await deleteNews(opt)
        if (!!data && data.code === 0) {
            this.getPages()
            message.success('删除成功')
        } else {
            if (!!data) {
                message.error(data.message)
            } else {
                message.error('接口异常')
                this.setState({
                    loading: false
                })
            }

        }
    }

    columns = [
        {
            title: '发布标题',
            dataIndex: 'title',
        },
        {
            title: '发布时间',
            dataIndex: 'record_time',
            valueType: 'date',
        },
        {
            title: '操作人员',
            dataIndex: 'operator',
            search: false,
        },
        {
            title: '操作时间',
            dataIndex: 'operatorTime',
            search: false,
        },
        {
            title: '操作',
            dataIndex: 'option',
            valueType: 'option',
            render: (_, record) => [
                <Popconfirm
                    onConfirm={() => { this.delete(record) }}
                    title="确认删除？">
                    <a style={{ color: 'rgb(75, 190, 205)' }} href="#">删除 </a>
                </Popconfirm>,
                <a style={{ color: 'rgb(75, 190, 205)' }} onClick={() => { this.getUpdateConstruction(record) }
                }> 编辑 </a>,
                <a style={{ color: 'rgb(75, 190, 205)' }} onClick={() => { this.getParticulars(record) }
                }> 详情 </a>
            ],
        },
    ];
    onChangeNewList(type, value) {
        if (type == 'current') {
            this.setState({
                current: value.current
            }, () => {
                this.getPages()
            })
        } else if (type == 'status') {
            this.setState({
                status: value,
                current: 1,
            }, () => {
                this.getPages()
            })
        }
    }
    onFinish = async (value) => {
        // value.recordTime != undefined ? value.recordTime = moment(value.recordTime).format('YYYY-MM-DD') : ''
        // value.title != undefined ? value.title = value.title : ''


        this.setState({
            loading: false,
        }, () => {
            this.getPages()
        })
    }
    handleConstructionVisible = async (value) => {
        this.setState({
            constructionVisible: value
        })
    }
    handleParticularsVisible = async (value) => {
        this.setState({
            particularsVisible: value
        })
    }
    handleUpdateConstructionVisible = async (value) => {
        this.setState({
            updateConstructionVisible: value
        })
    }
    render() {
        const { newContent, loading, current, status, constructionVisible, particularsVisible, particularsContent, updateConstructionVisible, updateConstructionContent, pageContent } = this.state
        const size = 368 / 150
        return (
            <Layout style={{ minHeight: '100%', minWidth: '100%', backgroud: 'none' }} id='homeId'>
                <Top />
                <Layout>
                    <div id='new'>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-10">
                            <Row className='choose_new'>
                                <Form name="horizontal_login" layout="inline" onFinish={this.onFinish}>
                                    <Form.Item
                                        name="title"
                                        label='发布标题'
                                    >
                                        <Input onChange={(value) => { this.setState({ title: value.target.value }) }} />
                                    </Form.Item>
                                    <Form.Item
                                        name="recordTime"
                                        label='发布时间'
                                    >
                                        <DatePicker onChange={(value) => { this.setState({ recordTime: moment(value).format('YYYY-MM-DD') != 'Invalid date' ? moment(value).format('YYYY-MM-DD') : '' }) }} />
                                    </Form.Item>
                                    <Form.Item shouldUpdate>
                                        <Button
                                            style={{ background: '#0093D8', color: '#fff' }}
                                            htmlType="submit"
                                        >
                                            搜索
                                            </Button>
                                    </Form.Item>
                                </Form>
                            </Row>
                            <div className='new_Content'>
                                <div className='button' style={{ float: "right", marginTop: '6px' }}>
                                    <Button onClick={() => this.handleConstructionVisible(true)} style={{ background: '#0093D8', color: '#fff' }}>
                                        新建新闻
                                    </Button>
                                </div>
                                <Tabs defaultActiveKey={status} onChange={(value) => this.onChangeNewList('status', value)}>
                                    <TabPane tab="发布" key="0">
                                    </TabPane>
                                    <TabPane tab="重要新闻" key="1">
                                    </TabPane>
                                    <TabPane tab="草稿" key="3">
                                    </TabPane>
                                </Tabs>
                                <Table onChange={(value) => this.onChangeNewList('current', value)} columns={this.columns} dataSource={newContent.pageContent} loading={loading} pagination={{ defaultCurrent: current, total: newContent.current, pageSize: 20 }} />
                                {/* <Table dataSource={pageContent} columns={this.columns} /> */}
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                    </div>
                    {constructionVisible ? <Construction getPages={this.getPages} userLoginInfo={this.props.userLoginInfo} constructionVisible={constructionVisible} handleConstructionVisible={this.handleConstructionVisible} /> : null}
                    <Particulars particularsContent={particularsContent} userLoginInfo={this.props.userLoginInfo} particularsVisible={particularsVisible} handleParticularsVisible={this.handleParticularsVisible} />
                    {updateConstructionVisible ? <UpdateConstruction getPages={this.getPages} updateConstructionContent={updateConstructionContent} userLoginInfo={this.props.userLoginInfo} updateConstructionVisible={updateConstructionVisible} handleUpdateConstructionVisible={this.handleUpdateConstructionVisible} /> : null}

                </Layout>
            </Layout>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(New))
